module.exports = __webpack_public_path__ + "static/project2lap-33493a4394a49092608e9330e6a57698.png";